import { makeStyles } from '@mui/styles';
const useStyles = makeStyles({
  emphasis: {
    fontWeight: 600
  }
});
export default useStyles;